import {API} from "@/Composables/api";

const getAiChats = async (params = {}) => {
    return API.get(route("ai-chats.index"), params);
};

const getAiChat = async (aiChat, params = {}) => {
    return API.get(route("ai-chats.show", aiChat), params);
};

const exportAiChat = async (aiChat, params = {}) => {
    return API.get(route("ai-chats.export", aiChat), params);
};

export {getAiChats, getAiChat, exportAiChat};
